import React from "react";
import styles from '../Styles/footer.css';

function Footer() {
    return(
        <footer>
            <div className="footerWrapper">
            <h1>Kornik 2023</h1>
            <p>Franciszek Mazur</p>
            <p>Kontakt: </p>
            <a href="mailto:f.krawczyk@lo1.elodz.edu.pl" className="wt">
                <p className="wt">f.krawczyk@lo1.elodz.edu.pl</p>
            </a>
        </div>
        </footer>
    );
}

export default Footer;